module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABH0lEQVQ4T9WUsUoDQRCGv1lJ5RuIhezZiD5EAl5aqwh2NoqI7xDT2dlZKEoKRfANvAvoQ2ihkBhLO0HQJu6IBxEveyecbJMtd2a+/f9hdoTARwLzmCKgJnYD0W2/BeaOkTuhBqjZArfi5agcS3Nw+X3/Y1lT2watg3byBaaF0soyhWvUnebiMrOL6r3Eg6zOA0r81JhUoKk9B+q815Zk7eHtd1x70dV/gJn6wseCA1N7ATxWtVyuMLVnwHN1oMiyrPbXC/p7BLxUAv71mzS1h8BrOGDPHqB8lAIn51Di4e1Yod5Ei4w+5/NzaBoozgcm0SZG2ygLBRb3QedA/J8kDHHSkWa/mxvssj5pYncw7AGzKN2xkrL8Kdo2oRZtcMtfkPWgFVXWQhMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/twojournal1.png
// module id = fGo6
// module chunks = 18